// extracted by mini-css-extract-plugin
module.exports = {"news":"News-module--news--2yUb5","heading":"News-module--heading--1HXDQ","cards":"News-module--cards--2XeAC","seeAllLink":"News-module--seeAllLink--_T_lj"};